import * as v from 'valibot'

export const QuoteTypeSchema = v.picklist(['all', 'volume', 'dynamic'])

export type QuoteType = v.InferOutput<typeof QuoteTypeSchema>

export const VolumeQuotesQuerySchema = v.object({
  startDate: v.optional(v.string()),
  endDate: v.optional(v.string()),
  carrier: v.optional(v.string()),
  quoteType: v.optional(QuoteTypeSchema),
})

export type VolumeQuotesQuery = v.InferOutput<typeof VolumeQuotesQuerySchema>
